
import { mapState } from 'pinia';
import { useWebview } from '@Stores/webview';

export default {
  name: 'EditoNavigation',
  props: {
    /**
     * Page breadcrumb
     * @see patterns/site-breadcrumb
     */
    breadcrumb: {
      type: Object,
      default: undefined,
    },
    /**
     * Current page
     */
    currentPage: {
      type: String,
      default: undefined,
    },
    /**
     * Navigation entries
     * @see patterns/select-list-navigation
     */
    navigation: {
      type: Array,
      default: undefined,
    },
    /**
     * Navigation title
     */
    title: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    ...mapState(useWebview, ['inWebview']),

    cssClass() {
      return {
        '-in-webview': this.inWebview,
      };
    },
  },
};
